import React from "react";
import { Link } from "react-router-dom";

/**
 * Checkbox GDPR riutilizzabili da incollare nei form di registrazione.
 * Salva due flag distinti:
 *  - acceptedTerms: obbligatorio (Privacy + Note Legali)
 *  - acceptedMarketing: opzionale (newsletter / comunicazioni commerciali)
 *
 * Conforme GDPR Art. 7: il consenso marketing NON è pre-spuntato e NON è
 * obbligatorio per accedere al servizio.
 */
export default function GdprConsentBlock({
  acceptedTerms,
  setAcceptedTerms,
  acceptedMarketing,
  setAcceptedMarketing,
  testidPrefix = "register",
}) {
  return (
    <div className="space-y-2.5 rounded-2xl border border-[var(--mp-border)] bg-[var(--mp-dash-bg)] p-4">
      <label className="flex items-start gap-2.5 cursor-pointer text-[12px] leading-relaxed">
        <input
          type="checkbox"
          checked={acceptedTerms}
          onChange={(e) => setAcceptedTerms(e.target.checked)}
          required
          data-testid={`${testidPrefix}-consent-terms`}
          className="mt-0.5 h-4 w-4 accent-[var(--mp-ink)] cursor-pointer shrink-0"
        />
        <span>
          Dichiaro di aver letto e accettato la{" "}
          <Link
            to="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-semibold text-[var(--mp-ink)]"
            data-testid={`${testidPrefix}-link-privacy`}
          >
            Privacy Policy
          </Link>{" "}
          e le{" "}
          <Link
            to="/note-legali"
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-semibold text-[var(--mp-ink)]"
            data-testid={`${testidPrefix}-link-terms`}
          >
            Note Legali
          </Link>{" "}
          del portale. <span className="text-rose-600 font-bold">*</span>
        </span>
      </label>

      <label className="flex items-start gap-2.5 cursor-pointer text-[12px] leading-relaxed">
        <input
          type="checkbox"
          checked={acceptedMarketing}
          onChange={(e) => setAcceptedMarketing(e.target.checked)}
          data-testid={`${testidPrefix}-consent-marketing`}
          className="mt-0.5 h-4 w-4 accent-[var(--mp-ink)] cursor-pointer shrink-0"
        />
        <span className="text-[var(--mp-muted)]">
          (Opzionale) Acconsento a ricevere comunicazioni commerciali, video
          formativi e novità da Marketing Parrucchieri SRL via email. Posso
          revocare il consenso in qualsiasi momento.
        </span>
      </label>

      <div className="text-[10px] text-[var(--mp-muted)] italic pt-1 border-t border-[var(--mp-border)]">
        <span className="text-rose-600 font-bold">*</span> Campo obbligatorio.
        Cliccando "Registrati" la tua scelta verrà registrata con data, ora e
        indirizzo IP a fini di prova del consenso (Art. 7 GDPR).
      </div>
    </div>
  );
}
